<div class="page" id="page_register">
    <div class="container">
        <div class="left">
            <img src="" />

        </div>

        <div class="right">
            <h1>A NEW FIGHT</h1>
            <div class="line small"></div>
            <p>
                
            </p>
            <div class="line full"></div>
            <form>
                <h1>FAÇA PARTE DA COMUNIDADE</h1>
                <p>
                    Há mais de 6 anos transformando <br/>
                    vidas através das artes marciais. <br/>
                    <br/><br/>
                    A NF Performance Club nasce para <br/>
                    quem busca mais do que apenas treinar.<br/>
                    <br/><br/>
                    Uma proposta exclusiva que combina <br/>
                    condicionamento físico, bem-estar, <br/>
                    estética e qualidade de vida através <br/>
                    de treinos dinâmicos e eficientes <br/>
                    com base nas artes marciais. <br/>
                    <br/><br/>
                    Cada detalhe foi pensado para <br/>
                    proporcionar uma experiência que <br/>
                    fortalece o corpo, desenvolve a mente <br/>
                    e ajuda você a construir <br/>
                    a sua melhor versão. <br/>
                </p>

                <label>Nome Completo</label>
                <input type="text" placeholder="Nome Completo" />
                <br/>
                <label>WhatsApp</label>
                <input type="whatsapp" placeholder="WhatsApp" />
                <br/>
                <label>Email</label>
                <input type="email" placeholder="Email" />
                <br/>
                <!-- <label>Nome Completo</label>
                <input type="password" placeholder="Senha" /> -->
                <button type="submit">Registrar</button>

                <p>
                    <fa-icon [icon]="faLock" />
                    Seus dados serão utilizados apenas para <br/>
                    contato da equipe NF.<br/>
                    Nunca compartilharemos suas informações com terceiros. <br/>
                    <br/><br/>  
                    Ao clicar em registrar, você concorda com os nossos <br/>
                    Termos de Uso e Política de Privacidade.
                </p>
            </form>
            <a href="#">ACESSAR</a>

        </div>

    </div>
</div>